const SWATCHES = {
  "Auburn": { hex: "#8B3A2A", sub: "Warm red" },
  "Blonde": { hex: "#E8C98A", sub: "Sunlit" },
  "Burgundy": { hex: "#5C1A2B", sub: "Wine" },
  "Copper": { hex: "#B87333", sub: "Glow" },
  "Dark Brown": { hex: "#3B2414", sub: "Cocoa" },
  "Honey Blonde": { hex: "#D8A663", sub: "Amber" },
  "Jet Black": { hex: "#0B0B0B", sub: "Onyx" },
  "Natural Black": { hex: "#1A1410", sub: "Classic" },
};

const ShopByColor = ({ colors = [], onSelect }) => {
  if (!colors.length) return null;
  return (
    <section
      data-testid="shop-by-color"
      className="border-b border-border/60"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-14 lg:py-20">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#B8935F] font-medium mb-2">
              Colorways
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
              Shop by color
            </h2>
            <p className="text-muted-foreground mt-2 text-sm max-w-lg">
              Handpicked hues from natural onyx to sunlit honey.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-4 lg:gap-6">
          {colors.map((c) => {
            const meta = SWATCHES[c.value] || { hex: "#999", sub: "" };
            return (
              <button
                key={c.value}
                data-testid={`shop-color-${c.value}`}
                onClick={() => onSelect(c.value)}
                className="group text-center"
              >
                <div
                  className="relative aspect-square rounded-full w-full shadow-[0_20px_40px_-24px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:scale-105 border border-border/40"
                  style={{ background: `radial-gradient(circle at 30% 30%, ${meta.hex}EE, ${meta.hex})` }}
                >
                  <div
                    className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ boxShadow: `inset 0 0 0 2px #B8935F` }}
                  />
                </div>
                <div className="mt-3 font-serif text-base text-foreground group-hover:text-[hsl(var(--primary))] transition-colors">
                  {c.value}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-0.5">
                  {meta.sub} · {c.count}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ShopByColor;
